import { Typography } from '@workspace/ui/common';
import { cn, getBackgroundClass } from '@workspace/lib';
import { processHeading } from '@workspace/lib/heading-utils';
import { getHeadingAlignClass } from '../PageApplications/layout';
import type { BinOptionsBlockProps } from './binOptions.types';
import { BinOptionList } from './ui';

export function BinOptions({ block }: BinOptionsBlockProps) {
  if (block?.enabled === false) return null;
  const { heading, headingAlign, hyperlinkText, items = [], backgroundColor } = block || {};

  const headingAlignClass = getHeadingAlignClass(headingAlign ?? 'left');

  const { text: resolvedHeadingText } = processHeading(heading);
  const backgroundClass = getBackgroundClass(backgroundColor);

  return (
    <div className={cn('w-full', backgroundClass)}>
      <div
        className={cn(
          'porta-container flex flex-col w-full gap-lg max-md:gap-lg md:py-3xl md:px-4xl py-xl max-md:px-md',
        )}
      >
        {resolvedHeadingText && (
          <div className={cn('w-full flex', headingAlignClass)}>
            <Typography variant="h3" className={cn('text-secondary-400!')}>
              {resolvedHeadingText}
            </Typography>
          </div>
        )}
        <div className="flex flex-col gap-lg md:gap-xl">
          {Array.isArray(items) && items.length > 0 && <BinOptionList items={items} hyperlinkText={hyperlinkText} />}
        </div>
      </div>
    </div>
  );
}
